<template lang="html">
  <b-container v-if="active_group">
    <b-row>
      <b-col>
        <h3>
          Group administration for
          {{ active_group.all_visible_plan_description }}
        </h3>
        <p>This group is limited to {{ active_group.user_limit }} users.</p>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <p
          v-if="approved_email_addresses.length >= active_group.user_limit"
          class="alert alert-info"
        >
          Group limit met. You will need to remove a user before adding another.
        </p>
        <div
          v-if="approved_email_addresses.length < active_group.user_limit"
          class="mb-5"
        >
          <b-form @submit="addAddress">
            <b-form-group
              id="email-group"
              label="Add a user's email address:"
              label-for="email-group-input"
              description="We'll never share these emails with anyone else."
            >
              <b-form-input
                id="email-group-input"
                v-model="new_email"
                type="email"
                required
                placeholder="Enter email"
              />
            </b-form-group>
            <b-btn type="submit" variant="primary">
              Add email address to this group
            </b-btn>
          </b-form>
        </div>
      </b-col>
      <b-col />
    </b-row>
    <b-row class="mb-5">
      <b-col>
        <h4>Current group users</h4>
        <b-table :items="approved_email_addresses" :fields="fields">
          <template v-slot:cell(actions)="data">
            <b-btn @click="removeAddress(data.item.email)">
              Remove
            </b-btn>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="alert alert-info">
          <h4 class="mb-3">Group license FAQs</h4>
          <p><b>How do I add users?</b></p>
          <p>Group licenses are linked together by email address.</p>
          <p>
            Enter your new user's email address in the form at the top of this
            page, then click "Add email address to this group" to add the user
            to your group license.
          </p>

          <p><b>How do my users access their accounts?</b></p>
          <p>
            Your users will need to create a trial account at
            <a href="https://app.soundslides.com">app.soundslides.com</a> using
            the same email address you have provided. If a user has already
            created a Soundslides trial account, you'll need to enter the email
            address they used when creating their account.
          </p>
          <p><b>What happens when I remove a user from my license?</b></p>
          <p>
            A removed user's account immedately reverts to an inactive "trial"
            account. The user will still be able to access their account and
            existing content, but will be subject to the limits of an unpaid
            trial account.
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import find from "lodash/find";
import map from "lodash/map";
import sortBy from "lodash/sortBy";
export default {
  name: "GroupEdit",
  data() {
    return {
      new_email: "",
      fields: ["email", "actions"]
    };
  },
  computed: {
    approved_email_addresses() {
      return sortBy(
        map(this.active_group.approved_email_addresses, i => {
          return {
            email: i
          };
        }),
        "email"
      );
    },
    active_group() {
      return find(this.$store.state.group_list, { key: this.$route.params.id });
    }
  },
  methods: {
    removeAddress(email) {
      var r = confirm(`Remove ${email} from this list?`);
      if (r == true) {
        this.firestoreRemoveUser(email);
      } else {
        console.log("Nope");
      }
    },
    addAddress(evt) {
      evt.preventDefault();
      var updateObj = {
        email: this.new_email,
        id: this.active_group.key
      };
      this.$store.dispatch("addUserToGroup", updateObj);
      this.$bvToast.toast(`${this.new_email} added.`, {
        title: "Group updated",
        autoHideDelay: 2000,
        toaster: "b-toaster-top-center",
        variant: "success"
      });
    },
    firestoreRemoveUser(email) {
      console.log("removing", email);
      var updateObj = {
        email: email,
        id: this.active_group.key
      };
      this.$store.dispatch("removeUserFromGroup", updateObj);
      this.$bvToast.toast(`${email} removed.`, {
        title: "Group updated",
        autoHideDelay: 2000,
        toaster: "b-toaster-top-center",
        variant: "danger"
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
